import React, { useState } from "react";
import PropTypes from "prop-types";

import { Select, SearchableInput } from "@octane/spark";

import copy from "../copy.json";

// store value for "I will decide later"; distinct sentinel for the Select option keeps it separate from the empty/unselected state
const DECIDE_LATER_MAKE_ID = "none";
const DECIDE_LATER_OPTION_VALUE = "__decide_later__";

const toSelectValue = (value) => {
    if (value == null) return "";
    if (value === DECIDE_LATER_MAKE_ID) return DECIDE_LATER_OPTION_VALUE;
    return value;
};

export const Make = ({ value, options, disabled, onChange, hideNoneOption = false }) => {
    const [searchPhrase, setSearchPhrase] = useState('');
    const normalizedSearchPhrase = searchPhrase.trim().toLowerCase().replace(/\s+/g, ' ');

    const handleSelection = (makeId) => {
        if (makeId === DECIDE_LATER_OPTION_VALUE) {
            setSearchPhrase('');
            return onChange({ id: DECIDE_LATER_MAKE_ID, name: DECIDE_LATER_MAKE_ID });
        }
        const makeSelected = options.find((option) => option.id === makeId);
        setSearchPhrase('');
        onChange(makeSelected);
    };

    const filteredOptions = normalizedSearchPhrase
        ? options.filter((option) =>
            option.name
                .toLowerCase()
                .replace(/\s+/g, ' ')
                .includes(normalizedSearchPhrase)
          )
        : options;
    const showNoneOption = !hideNoneOption && !normalizedSearchPhrase;
    const showNoResults = !showNoneOption && filteredOptions.length === 0;

    const selectValue = toSelectValue(value);

    return (
        <Select
            id="select-make"
            label={copy.fields.make.label}
            placeholder={copy.fields.make.placeholder}
            value={selectValue}
            disabled={disabled}
            onChange={handleSelection}
            searchable
            searchComponent={
                <div
                    onKeyDownCapture={(event) => event.stopPropagation()}
                    onKeyUpCapture={(event) => event.stopPropagation()}
                >
                    <SearchableInput
                        id="make-search"
                        placeholder={copy.fields.make.searchPlaceholder}
                        value={searchPhrase}
                        onChange={(nextValue) => setSearchPhrase(nextValue)}
                        onSearch={() => {}}
                        onClear={() => setSearchPhrase("")}
                        variant="primary"
                    />
                </div>
            }
        >
            {showNoneOption && (
                <Select.Option key="none" value={DECIDE_LATER_OPTION_VALUE}>
                    {copy.fields.make.notSure}
                </Select.Option>
            )}

            {showNoResults && (
                <Select.Option key="no-results" value="__no_results__" disabled>
                    {copy.fields.make.noResults}
                </Select.Option>
            )}

            {!showNoResults && (
                filteredOptions.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                        {option.name}
                    </Select.Option>
                ))
            )}
        </Select>
    );
};

Make.propTypes = {
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    hideNoneOption: PropTypes.bool,
};
